import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Injectable } from "@angular/core";
import { finalize, Observable } from "rxjs";
import { DataService } from "../../core/core-services/services/dataservices/data.service";
import { LoadingService } from "src/app/components/loading/loading.service";

@Injectable()
export class ShortcutListResolver  {
  constructor(private dataService: DataService, private loadingService: LoadingService) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    // this.loadingService.show();
    const { categoryId, lv1CategoryId, lv2CategoryId } = route.params;
    const limit = route.queryParams.shortcutId ? 200 : 10;

    let url = `v1/user/shortcut?skip=0&limit=${limit}&order_by=shortcut,asc`;

    if (categoryId !== "all") {
      url += `&category_id=${categoryId}`;
    }
    if (lv1CategoryId) {
      url += `&sub_categories_lv1_id=${lv1CategoryId}`;
    }
    if (lv2CategoryId) {
      url += `&sub_categories_lv2_id=${lv2CategoryId}`;
    }
    return this.dataService
      .get({
        url,
        isLoader: false,
      })
      .pipe(
        finalize(() => {
          // this.loadingService.hide()
        })
      );
  }
}
